import { useState, useEffect, useMemo, useCallback, useContext } from 'react';
import {
  mathFormat,
  getCountryNameByCountryCode,
} from '@/pages/intelligence/utils/commonUtils';
import GameDefaultIcon from '@/pages/intelligence/assets/imgs/common/game-default.svg';
import defaultKolIcon from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import {
  ECHARTSCOLOR,
  IMGE_STAMDARDS_CANVAS,
} from '@/pages/intelligence/utils/echartsConst';
import { BarChartCommonProps } from '../_config/interface';
import { gameIDRex } from '../_config/topchartsChartUtils';
import { getIfPercentage } from '@/pages/intelligence/utils/common';
import {
  AnnieEchartImg,
  SensorTowerEchartImg,
} from '@/pages/intelligence/pages/TopCharts/_config/base64Img';
import { canvasOption } from '@/pages/intelligence/utils/radiusImg';
import ChartBubble, {
  TOP_CHARTS_TYPES,
} from '@/pages/intelligence/components/ChartBubble';
import { getCountryFlag } from '@/pages/home/_config/countries';
import {
  BAR_GRID_TOP,
  BAR_GRID_TOP_WITH_LABEL,
} from '@/pages/intelligence/pages/TopCharts/_config/echarts';
// import useCountriesNames from '@intelligence/hooks/useCountriesNames';
import {
  GLOBAL_MARKETS,
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
} from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { ThemeContext } from '@/pages/home/wrappers/common';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';

const getCountryCode = (payload: any): string => {
  if (!payload) return '';
  return (payload?.cover || payload?.market)?.toLowerCase();
};

// 通用柱状图数据转换格式
/** *********
 const barNameList = useMemo(() => {
  return tableData?.map((item: any) => {
    const nameStr = item?.name || item?.market || '';
    return getCountryNameByCountryCode(regionsCountries, nameStr)
  }) || [];
}, [tableData]);

const barSeriesData = useMemo(() => {
  return tableData?.map((item: any, i: number): any => {
    let barNum = item.metrics ? item.metrics?.find((item: any) => item.metric == metric)?.value : 0;
    if (getIfPercentage(metric)) {
      barNum = barNum * 100;
    }
    const nameStr = item?.name || item?.market || '';
    return {
      type: 'bar',
      name: getCountryNameByCountryCode(regionsCountries, nameStr),
      value: barNum,
      market: item.market,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) => `${newMathFormat(Number(params.value), true) + (getIfPercentage(metric) ? '%' : '')}`,
      }
    }
  }
  );
}, [tableData, metric]);

 // 获取饼图hooks
  const {
    pieOption
  } = useSinglePieCharts({
    pieData: pieSeriesData,
    pieTitle: gameName,
    setChartLoading,
    chartLoading,
    chartType,
  });
 * **************/

export default function useBarCharts(props: BarChartCommonProps) {
  const {
    showTitle = true,
    title,
    seriesData = [],
    isShowLegend = false,
    dataSourceEachers = [], // 贴花个数，默认为0，则不配置,一般按数据源来匹配
    tooltipFormatter,
    xAxisBarConfig,
    gridBarConfig,
    legendData, // 自定义X轴游戏展示
    colorArr,
    legendSlectedMode = false, //
    setChartLoading,
    barOrPieData = [],
    titleNow = '',
    tooltipExtraConfig,
    topChartsType,
    barNameList,
    cardWidth,
    imageType = 'mobile',
    ifNoBarImg = false, // 是否 没有 x轴的富文本图片（目前有的为游戏、国旗、公司）
    chartType = 'bar',
    barCurSeries = [],
    ifPercentage = false,
    isPercentageDecimal = false,
    ifNeedSourceImg = true,
    isStackBar = false, // 是否是堆叠图
    enableAutoBarWidth = false,
    gameIdKeyName = 'unifiedId',
    showBarLabel = true, // 是否在柱子上展示数值，默认展示
    startDate,
    endDate,
    regionSegVal = 'market',
    timeText = '',
    valueFormatter,
    barListValue = '',
    ifHasOtherHeadContent = false,
    yAxisFormatter,
    secondTitleRight,
    useMarketFilterApiKey = '',
    gameHighId = '',
  } = props;

  // console.log('useBarCharts2', props);

  // 获取颜色主题值，通过ThemeContext消费者useContext
  const { themeValue } = useContext(ThemeContext);
  const GameDefault = imageType === 'user' ? defaultKolIcon : GameDefaultIcon;
  const { locale, formatMessage } = useIntlExtend();
  // 获取全局国家地区数据 -- 旧hooks获取
  const { regionOptions: regionOptionsMarketFilter } = useMarketFilterApi(
    useMarketFilterApiKey === '' ? {} : { filterType: useMarketFilterApiKey },
  );
  // 获取全局国家地区数据 -- 全局缓存获取
  const regionOptionsCommon = useQueryDefinition('mobileRegionCountry');
  // 获取公共筛选配置
  const regionOptions = useMemo(() => {
    if (useMarketFilterApiKey === 'NOT_REQUIRED') {
      return regionOptionsCommon;
    }
    return regionOptionsMarketFilter;
  }, [regionOptionsMarketFilter, regionOptionsCommon, useMarketFilterApiKey]);

  const getLocalizedCountryName = useCallback(
    (code: string) => {
      if (code?.toLowerCase() === 'others') {
        return formatMessage({
          id: 'dbi_others',
          defaultMessage: 'Others',
        }) as string;
      }

      if (GLOBAL_MARKETS.includes(code)) {
        return formatMessage({
          id: `dbi_${code}`,
          defaultMessage: code,
        }) as string;
      }

      return getCountryNameByCountryCode(
        regionOptions || [],
        code,
        regionSegVal,
      );
    },
    [locale, regionSegVal, regionOptions],
  );

  const option = {
    grid: {
      left: '5px',
      right: '0px',
      top: '25px',
      bottom: '78px',
    },
    tooltip: {
      trigger: 'axis',
      lineStyle: {
        color: 'rgba(0,0,0,0.25)',
        width: 2,
        type: 'solid',
      },
      showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: '#96c5eb',
          opacity: '0.01',
          width: 'auto',
        },
      },
      // 进行数据处理,去掉提示框中一些x轴坐标为空的数据显示.
      formatter: {},
      backgroundColor: 'rgba(0,0,0,0)',
    },
    legend: {
      show: false,
    },
    yAxis: [
      {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#E5E5E5',
          },
        },
        axisLabel: {
          color: ' #000000',
          fontSize: 12,
          opacity: 0.45,
          formatter(value: number) {
            return `${value}%`;
          },
        },
      },
    ],
    xAxis: {}, // barxAxis,
    series: [], // barSeries,
  };

  // 实例的数据
  const [series, setSeries] = useState<any>([]);
  const [addConfig, setAddConfig] = useState<any>({});
  const [iconOption, setIconOption] = useState<any>({}); // 游戏图片richlist
  const [axisRich, setAxisRich] = useState({}); // 国家图片rich
  const [cavasRich, setCavasRich] = useState<any>({}); // 游戏图片rich
  const [barOption, setBarOption] = useState<any>(option);
  // 默认浮窗内容
  const formatterTooltip = (params: any[]) => {
    return ChartBubble({
      data: params,
      titleNow,
      topChartsType,
      imageType,
      ifNoBarImg,
      isPercent: ifPercentage,
      isPercentageDecimal,
      ifNeedSourceImg,
      serieNameFormatter: getIfCountriesBar
        ? getLocalizedCountryName
        : undefined,
      startDate,
      endDate,
      timeText,
      valueFormatter,
      barListValue,
      ifHasOtherHeadContent,
      isStackBar,
      secondTitleRight,
      dataSourceEachers,
    });
  };

  // 默认贴花内容
  const getAriaConfig = (list: any) => {
    const decalsList = [
      {
        symbol: 'none',
      },
      {
        symbol: 'rect',
        color: 'rgba(255, 255, 255, 0.12)',
        dashArrayX: [4, 16],
        dashArrayY: [1, 0],
        rotation: 45,
      },
    ];
    const decalObj = {
      symbol: 'circle',
      color: 'rgba(255, 255, 255, 0.24)',
      dashArrayX: [5, 8],
      dashArrayY: [5, 8],
    };

    if (list?.length > 1) {
      return {
        enabled: true,
        decal: {
          show: true,
          decals: list?.length == 2 ? decalsList : [...decalsList, decalObj],
        },
      };
    }
    return {};
  };

  const getGridConfig = (list: any) => {
    const top = showBarLabel ? BAR_GRID_TOP_WITH_LABEL : BAR_GRID_TOP;
    if (list?.length > 1) {
      return {
        left: '10px',
        right: '0px',
        // top: '20px',
        top,
        bottom: '70px',
      };
    }
    return {
      left: '10px',
      right: '0px',
      // top: '20px',
      top,
      bottom: isShowLegend ? '45px' : 3,
    };
  };

  // 悬浮窗显示内容格式化
  const getLegendConfig = (list: any) => {
    if (list?.length > 1) {
      return {
        data: [
          {
            name: 'appannie',
            icon: AnnieEchartImg,
          },
          {
            name: 'sensortower',
            icon: SensorTowerEchartImg,
          },
        ],
        bottom: '-5px',
        width: '100%',
        itemWidth: 36,
        itemHeight: 16,
        itemGap: 20,
        textStyle: {
          color: '#888888',
          fontSize: 12,
        },
        selectedMode: true,
      };
    }
    return {
      show: isShowLegend,
      // show: true,
      type: 'scroll',
      orient: 'horizontal', // 横向
      pageIconColor: '#ff781f', // 翻页箭头颜色
      selectedMode: false,
      pageIconSize: 13,
      pageTextStyle: {
        color: '#999', // 翻页数字颜色
      }, // 翻页数字设置
      icon: 'circle',
      itemWidth: 20,
      itemHeight: 10,
      bottom: 10,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
      },
    };
  };

  const getOptions = () => {
    const option = {
      ariaConfig: getAriaConfig(dataSourceEachers),
      legendConfig: getLegendConfig(dataSourceEachers),
      gridConfig: gridBarConfig
        ? gridBarConfig
        : getGridConfig(dataSourceEachers),
      tooltipConfig: {
        trigger: 'axis',
        // backgroundColor: '#FFFFFF',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        padding: 0,
        borderWidth: 0,
        textStyle: {
          color: '#FFFFFF',
          fontSize: 12,
        },
        confine: true,
        hideDelay: 200,
        triggerOn: 'mousemove',
        axisPointer: {
          type: 'shadow',
        },
        formatter: tooltipFormatter ? tooltipFormatter : formatterTooltip,
        ...(tooltipExtraConfig || {}),
      },
      xAxisConfig: {
        type: 'category',
        fontSize: 12,
        rotate: 30,
        axisTick: {
          alignWithLabel: gameHighId === '', // x轴刻度线与标签对齐
          lineStyle: {
            color: '#BFBFBF',
            // 透明度会展示到虚线，暂时用纯色代替
            // color: '#000',
            // opacity: 0.25,
            width: 1,
          },
        },
        axisLine: {
          show: true,
          // onZero: false,//当y轴有负数时,让x轴下落在y轴最小值
          lineStyle: {
            color: '#BFBFBF',
            width: 1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          interval: 0,
          color: '#000',
          align: 'center',
          opacity: 0.45,
          fontSize: 12,
          formatter: '', // 使用getImage()替代富文本,
          ...(xAxisBarConfig?.axisLabel || {}),
        },
      },
      yAxisConfig: [
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => {
              if (typeof yAxisFormatter === 'function')
                return yAxisFormatter(value);
              // 如果是需要展示百分比的柱状图，则返回百分比Y轴
              if (getIfPercentage(title)) {
                return `${value}%`;
              }
              if (topChartsType == 'steamSales—players_by_country') {
                return `${mathFormat(value, true)}%`;
              }
              if (topChartsType == 'steamSales—countries-players_by_country') {
                return `${mathFormat(value, true)}%`;
              }
              if (ifPercentage) {
                return isPercentageDecimal
                  ? `${mathFormat(value * 100, true)}%`
                  : `${mathFormat(value, true)}%`;
              }
              return mathFormat(value, true);
            },
            // color: ' #000000',
            color: '#838697',
            fontSize: 12,
            // opacity: 0.45,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E5E5E5',
            },
          },
          show: true,
        },
      ],
      series,
    };
    return option;
  };

  const defaultOptionMap: {
    legend: any;
    grid: any;
    tooltip: any;
    [key: string]: any;
  } = {
    legend: {
      data: legendData,
      selectedMode: legendSlectedMode,
      itemWidth: 16,
      itemHeight: 16,
      itemGap: 18,
      width: '100%',
    },
    grid: {
      left: '5px',
      right: '0%',
      // bottom: '5%',
      bottom: 54,
      containLabel: true,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        label: {
          backgroundColor: '#6a7985',
        },
      },
      backgroundColor: 'rgba(0,0,0,0)',
    },
    yAxis: [
      {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#E5E5E5',
          },
        },
      },
    ],
  };

  /**
   * 附加props传入的配置
   * @param type 类型，在charts中预定义的字段类型，如legend（图例）
   * @returns
   */
  const getAddedConfig = (type: string) => {
    const key = `${type}Config`;
    const added = addConfig[key];
    let _config = defaultOptionMap[type] || {};
    if (added) {
      _config = Object.assign(_config, added);
    }
    return _config;
  };

  // 当配置是数组，需要每项都改变的时候
  const getAddedConfigArray = (type: string) => {
    const key = `${type}Config`;
    const added = addConfig[key];
    const _config = defaultOptionMap[type] || [];
    if (added) {
      added.forEach((item: any, index: any) => {
        _config[index] = Object.assign(_config[index], item);
        // 非百分比的数据，才展示整数
        if (true) {
          // if (isMinInterval) {
          // _config[index] = { show: true, type: "value" };
          _config[index] = { ..._config[index], minInterval: 1 };
        }
      });
    } else {
      _config.forEach((item: any, index: any) => {
        // if (isMinInterval) {
        if (true) {
          // item = { show: true, type: "value" };
          item = { ...item, minInterval: 1 };
        }
      });
    }
    return _config;
  };

  const init = () => {
    if (topChartsType === 'steamSales—players_by_country' || isStackBar) {
      setSeries(barCurSeries);
    } else {
      let series = {
        type: 'bar',
        data: seriesData,
      } as any;

      if (
        !enableAutoBarWidth &&
        ![
          'pc-console-kpioverview',
          'pcconsole-country-ampere-bar',
          'steamSales—countries-players_by_country',
        ].includes(topChartsType as string)
      ) {
        series = {
          ...series,
          barWidth: 92,
          name: '',
        };
      }
      if (gameHighId !== '') {
        const indexNum = barOrPieData?.findIndex(
          (item: any) => item?.app_id === gameHighId,
        );
        series = {
          ...series,
          markArea: {
            itemStyle: {
              color: 'rgba(50, 111, 240, 0.08)', // 设置背景色和透明度
            },
            data: [
              [
                {
                  xAxis: indexNum,
                },
                {
                  xAxis: indexNum,
                },
              ],
            ],
          },
        };
      }
      setSeries([series]);
    }
    const options = getOptions();
    setAddConfig(options);
  };

  const getIfCountriesBar = useMemo(() => {
    switch (topChartsType) {
      case 'stats-countries-bar':
      case 'stats-rpdedition-bar':
      case 'stats-rpdedition-bar-country':
      case 'pcconsole-country-bar':
      case 'pcconsole-country-ampere-bar':
      case 'pcconsole-country-bar-pcu':
      case 'steamSales—countries-players_by_country':
        return true;
      default:
        return false;
    }
  }, [topChartsType, ifNoBarImg, chartType]);

  const awaitChartIconUndateSeries = async (
    list: any[],
    themeValue: string,
    isCountryBar: boolean,
  ) => {
    const imageUrl = {} as any;
    try {
      list?.map((item) => {
        let id =
          topChartsType === 'details-mobile-overlap'
            ? item?.[getNameKey(topChartsType)]
            : item?.unifiedId ||
              item?.unified_id ||
              item?.app_id ||
              item?.id ||
              item?.[gameIdKeyName];
        id = gameIDRex(id);
        const countryCode = getCountryCode(item);
        const countryKey = gameIDRex(countryCode);
        const urlGameTemp = item?.gameIcon || item?.cover || GameDefault;
        const urlCountryTemp = getCountryFlag(countryCode);
        imageUrl[isCountryBar ? countryKey : id] = isCountryBar
          ? urlCountryTemp
          : urlGameTemp;
      });

      const widthTemp =
        IMGE_STAMDARDS_CANVAS[isCountryBar ? 'market' : imageType]?.width;
      const heightTemp =
        IMGE_STAMDARDS_CANVAS[isCountryBar ? 'market' : imageType]?.height;

      let iconOption = {} as any;
      // 添加themeValue值，判断是否需要对canvas图片进行反转--包括国家图片
      iconOption = await canvasOption(
        imageUrl,
        widthTemp,
        heightTemp,
        5,
        themeValue,
        isCountryBar,
      );
      setIconOption({ ...iconOption });
    } catch (err) {
      console.error(err);
    }
    if (setChartLoading && chartType == 'bar') setChartLoading(false);
  };

  useEffect(() => {
    if (
      seriesData &&
      Array.isArray(seriesData) &&
      barOrPieData &&
      Array.isArray(barOrPieData)
    ) {
      init();
      // 画cavas可视化游戏图片
      if (!ifNoBarImg) {
        awaitChartIconUndateSeries(barOrPieData, themeValue, getIfCountriesBar);
      }
    }
  }, [
    startDate,
    endDate,
    showBarLabel,
    seriesData,
    title,
    titleNow,
    tooltipFormatter,
    tooltipExtraConfig,
    barOrPieData,
    getLocalizedCountryName,
    themeValue,
    enableAutoBarWidth,
  ]);

  // 给X轴更新cavas画好的图片
  useEffect(() => {
    const { xAxis } = barOption;
    if (Array.isArray(xAxis.data) && JSON.stringify(iconOption) !== '{}') {
      const ids = Object.keys(iconOption);
      let cavasRichTemp: any = {};

      ids.map((id) => {
        cavasRichTemp[id] = {
          align: 'center',
          width:
            IMGE_STAMDARDS_CANVAS[getIfCountriesBar ? 'market' : imageType]
              ?.width,
          height:
            IMGE_STAMDARDS_CANVAS[getIfCountriesBar ? 'market' : imageType]
              ?.height,
          backgroundColor: !iconOption[id]
            ? '#fff'
            : {
                image: iconOption[id],
              },
        };
      });

      if (gameHighId !== '') {
        cavasRichTemp = {
          ...cavasRichTemp,
          boldB: {
            color: '#262832',
            fontSize: 12,
            fontWeight: 'bold',
          },
        };
      }

      setCavasRich(cavasRichTemp);

      setBarOption({
        ...barOption,
        xAxis: {
          ...xAxis,
          axisLabel: {
            ...xAxis.axisLabel,
            rich: cavasRichTemp,
          },
        },
      });
    }
    // }
  }, [iconOption]);

  const getNameKey = (topChartsType: string | undefined) => {
    switch (topChartsType) {
      case 'rpd':
        return 'unifiedId';
      case PC_CONSOLE_COMBINE_ENTITY_TYPE:
      case 'pcMetricsTable':
        return 'unified_id';
      case 'newrelease':
      case 'upcoming':
      case 'stats-activeuser-bar':
      case 'stats-rpdedition-bar':
      case 'stats-rpdedition-bar-country':
      case 'pcconsole-country-bar':
      case 'pcconsole-country-ampere-bar':
      case 'pcconsole-country-bar-pcu':
      case 'steamSales—players_by_country':
      case 'steamSales—players_by_country-topcharts':
      case TOP_CHARTS_TYPES.TOP_COMPANIES_REVENUE:
      case TOP_CHARTS_TYPES.TOP_COMPANIES_DOWNLOADS:
      case TOP_CHARTS_TYPES.TOP_COMPANIES_MENTIONS:
        return 'app_id';
      case 'details-mobile-overlap':
      case 'topcharts-console-japan-sales':
        return 'id';
      default:
        return gameIdKeyName;
    }
  };

  useEffect(() => {
    if (
      seriesData &&
      Array.isArray(seriesData) &&
      barOrPieData &&
      Array.isArray(barOrPieData)
    ) {
      /** 计算可视化X轴宽度 */
      let barItemWidth = null;
      if (cardWidth) {
        barItemWidth = (cardWidth - 100) / barOrPieData?.length;
      }
      if (setChartLoading && chartType == 'bar' && ifNoBarImg)
        setChartLoading(false);
      setBarOption({
        aria: getAddedConfig('aria') || {},
        title: {
          show: !!(showTitle && title),
          text: title || '',
          textStyle: {
            fontSize: 14,
          },
        },
        color: colorArr || ECHARTSCOLOR,
        tooltip: getAddedConfig('tooltip') || {},
        legend: getAddedConfig('legend') || {},
        grid: getAddedConfig('grid') || {},
        xAxis: {
          type: 'category',
          axisTick: {
            alignWithLabel: gameHighId === '',
          },
          axisLabel: {
            interval: 0,
            width: barItemWidth ? barItemWidth : undefined,
            overflow: 'truncate',
            ellipsis: '...',
            formatter(value: any) {
              let frontKey = '';
              let nameStr = '';
              let nameRich = 'avanametar';
              if (getIfCountriesBar) {
                frontKey = gameIDRex(value);
                nameStr = getLocalizedCountryName?.(value) || value;
              } else {
                const id = barOrPieData?.find(
                  (item: any) => (item.gameName || item.name) === value,
                )?.[getNameKey(topChartsType)];
                if (gameHighId !== '' && id === gameHighId) {
                  nameRich = 'boldB';
                }
                frontKey = gameIDRex(id);
                nameStr = value;
              }

              return [`{${frontKey}|}\n\n{${nameRich}|${nameStr}}`];
            },
            margin: ifNoBarImg ? 0 : 20,
            rich: ifNoBarImg ? {} : cavasRich,
            ...(xAxisBarConfig?.axisLabel || {}),
          },
          data: barNameList,
          axisPointer: xAxisBarConfig?.axisPointer || {},
          ...(xAxisBarConfig?.animationSetting || {}),
        },
        yAxis: getAddedConfigArray('yAxis'),
        series,
      });
    }
  }, [
    showTitle,
    title,
    series,
    addConfig,
    axisRich,
    ifNoBarImg,
    cavasRich,
    chartType,
    barOrPieData,
    titleNow,
  ]);

  return {
    barOption,
  };
}
